import React, { useState, useEffect } from 'react';
import {Home, Activity, BarChart2, TrendingUp, Fingerprint} from 'lucide-react';
import './dashboard.css';

const DynamicWindow = ({ fetchDataScience, darkMode }) => {
  const [activeTab, setActiveTab] = useState('overview');
  const [anomalyData, setAnomalyData] = useState(null);
  const [clusterData, setClusterData] = useState(null);
  const [predictiveData, setPredictiveData] = useState(null);

  const tabs = [
    { key: 'overview', label: 'Overview', icon: <Fingerprint className="w-5 h-5" /> },
    { key: 'anomaly', label: 'Anomaly Detection', icon: <Activity className="w-5 h-5" /> },
    { key: 'clustering', label: 'Clustering', icon: <BarChart2 className="w-5 h-5" /> },
    { key: 'predictive', label: 'Predictive Modeling', icon: <TrendingUp className="w-5 h-5" /> },
  ];

  useEffect(() => {
    if (activeTab === 'anomaly') {
      fetchDataScience('anomaly').then(setAnomalyData);
    } else if (activeTab === 'clustering') {
      fetchDataScience('clustering').then(setClusterData);
    } else if (activeTab === 'predictive') {
      fetchDataScience('predictive').then(setPredictiveData);
    }
  }, [activeTab, fetchDataScience]);

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return renderOverview();
      case 'anomaly':
        return renderAnomalyDetection();
      case 'clustering':
        return renderClustering();
      case 'predictive':
        return renderPredictiveModeling();
      default:
        return null;
    }
  };

  const renderOverview = () => (
    <div className="dynamic-window-content">
      <h3>Welcome to the Dashboard</h3>
      <p>Use the tabs above to explore anomaly detection, clustering, and predictive modeling insights.</p>
      <div className="overview-grid">
        <div className="overview-card">
          <h4>Anomalies Detected</h4>
          <p>{anomalyData ? anomalyData.length : 'Loading...'}</p>
        </div>
        <div className="overview-card">
          <h4>Clusters Identified</h4>
          <p>{clusterData ? clusterData.labels.length : 'Loading...'}</p>
        </div>
        <div className="overview-card">
          <h4>Predictions Generated</h4>
          <p>{predictiveData ? predictiveData.labels.length : 'Loading...'}</p>
        </div>
      </div>
    </div>
  );

  const renderAnomalyDetection = () => (
    <div className="dynamic-window-content">
      <h3>Anomaly Detection</h3>
      <p>{anomalyData ? anomalyData.join(', ') : 'Loading anomaly data...'}</p>
    </div>
  );

  const renderClustering = () => (
    <div className="dynamic-window-content">
      <h3>Clustering</h3>
      <p>{clusterData ? JSON.stringify(clusterData) : 'Loading clustering data...'}</p>
    </div>
  );

  const renderPredictiveModeling = () => (
    <div className="dynamic-window-content">
      <h3>Predictive Modeling</h3>
      <p>{predictiveData ? JSON.stringify(predictiveData) : 'Loading predictive data...'}</p>
    </div>
  );

  return (
    <div className="rounded-xl shadow-glow bg-white dark:bg-gray-800 overflow-hidden h-full">
      {/* Tab Navigation */}
      <div className="tab-navigation">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`tab-button ${activeTab === tab.key ? 'active' : ''}`}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div>{renderContent()}</div>
    </div>
  );
};

export default DynamicWindow;